
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[locale]/collections",
      function () {
        return require("private-next-pages/[region]/[locale]/collections/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[locale]/collections"])
      });
    }
  